import { render } from "./CGridLinkColumn.vue?vue&type=template&id=0d22c67b&scoped=true"
import script from "./CGridLinkColumn.vue?vue&type=script&lang=js"
export * from "./CGridLinkColumn.vue?vue&type=script&lang=js"

import "./CGridLinkColumn.vue?vue&type=style&index=0&id=0d22c67b&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d22c67b"]])

export default __exports__